import { render, staticRenderFns } from "./schema-table.vue?vue&type=template&id=3b4aab0e"
import script from "./schema-table.vue?vue&type=script&lang=js"
export * from "./schema-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4aab0e')) {
      api.createRecord('3b4aab0e', component.options)
    } else {
      api.reload('3b4aab0e', component.options)
    }
    module.hot.accept("./schema-table.vue?vue&type=template&id=3b4aab0e", function () {
      api.rerender('3b4aab0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/provider/schema-table.vue"
export default component.exports